/* bc-customize-ride.js — behaviour for the "CUSTOMIZE YOUR RIDE" / "ADD WHAT YOU WANT"
   accessory panel (snippets/bc-customize-ride.liquid). A copy of the Rambo Bikes buy-box
   panel: bar toggles the panel, tabs switch lists, ADD puts one in the cart and flips to
   REMOVE, VIEW MORE opens a quick view, Watch Video opens a lightbox.

   Everything is event-delegated on document and initialised by a short poll, because
   Impulse can inject the buy-box blocks by AJAX after this script has run. */
(function () {
  'use strict';

  var ROOT_SEL = '[data-bc-cr]';
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };

  /* ---------- helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, theme.moneyFormat || '${{amount}}');
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }
  function lock(on) {
    document.documentElement.classList.toggle('bc-cr-lock', on);
    document.body.classList.toggle('bc-cr-lock', on);
  }

  /* Header bubble — refresh the count without opening the drawer (Rambo doesn't open it either). */
  function refreshCartCount() {
    fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('.cart-link__bubble-num, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        qsa('.cart-link__bubble').forEach(function (el) { el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0); });
        document.dispatchEvent(new CustomEvent('bc-cr:cart', { detail: cart }));
        markInCart(cart);
      })
      .catch(function () {});
  }

  /* Items already in the cart show REMOVE on load, so a refresh doesn't lie. */
  function markInCart(cart) {
    var ids = {};
    (cart.items || []).forEach(function (it) { ids[String(it.variant_id)] = true; });
    qsa('.bc-cr-item').forEach(function (item) {
      var add = qs('.bc-cr-add', item), rem = qs('.bc-cr-remove', item);
      if (!add || !rem) return;
      var inCart = !!ids[item.getAttribute('data-variant')];
      add.style.display = inCart ? 'none' : 'inline-block';
      rem.style.display = inCart ? 'inline-block' : 'none';
    });
  }

  /* ---------- bar ---------- */
  function toggleBar(bar) {
    var wrap = bar.closest(ROOT_SEL);
    var panel = qs('.bc-cr-panel', wrap);
    var open = panel.style.display === 'block';
    panel.style.display = open ? 'none' : 'block';
    bar.classList.toggle('active', !open);
    bar.setAttribute('aria-expanded', String(!open));
    bar.textContent = open ? wrap.getAttribute('data-closed-label') : wrap.getAttribute('data-open-label');
  }

  /* ---------- tabs ---------- */
  function openTab(btn) {
    var wrap = btn.closest(ROOT_SEL);
    var key = btn.getAttribute('data-tab');
    qsa('.bc-cr-tab-item', wrap).forEach(function (p) { p.style.display = p.getAttribute('data-tab-panel') === key ? 'block' : 'none'; });
    qsa('.bc-cr-tab', wrap).forEach(function (b) { b.classList.toggle('active', b === btn); });
    var content = qs('.bc-cr-tab-content', wrap);
    if (content) content.scrollTop = 0;
  }

  /* ---------- cart ---------- */
  function addToCart(form) {
    var add = qs('.bc-cr-add', form), rem = qs('.bc-cr-remove', form);
    var id = form.getAttribute('data-variant');
    if (!add || !id) return;
    add.disabled = true;
    var label = add.textContent;
    add.textContent = 'ADDING…';
    /* Single-item form post (not the {items:[...]} shape): the response is then the line
       item itself, which is what the theme and the cart apps listening on /cart/add expect. */
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: 'form_type=product&id=' + encodeURIComponent(id) + '&quantity=1'
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed ' + r.status); return r.json(); })
      .then(function () {
        add.textContent = label; add.disabled = false;
        add.style.display = 'none';
        if (rem) rem.style.display = 'inline-block';
        refreshCartCount();
      })
      .catch(function () {
        add.textContent = 'TRY AGAIN'; add.disabled = false;
        setTimeout(function () { add.textContent = label; }, 2000);
      });
  }

  function removeFromCart(btn) {
    var form = btn.closest('.bc-cr-form');
    var add = qs('.bc-cr-add', form);
    var id = form.getAttribute('data-variant');
    var updates = {}; updates[id] = 0;
    btn.disabled = true;
    fetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { if (!r.ok) throw new Error('remove failed ' + r.status); return r.json(); })
      .then(function () {
        btn.disabled = false;
        btn.style.display = 'none';
        if (add) add.style.display = 'inline-block';
        refreshCartCount();
      })
      .catch(function () { btn.disabled = false; });
  }

  /* ---------- quick view ---------- */
  function openQuickView(handle) {
    var qv = qs('[data-bc-cr-quickview]');
    if (!qv) return;
    fetch(root() + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        qs('[data-qv-title]', qv).textContent = p.title;
        qs('[data-qv-price]', qv).textContent = money(p.price);
        var desc = qs('[data-qv-desc]', qv);
        desc.innerHTML = p.description || '';
        qsa('style, script', desc).forEach(function (n) { n.parentNode.removeChild(n); });
        var img = qs('[data-qv-image]', qv);
        if (p.featured_image) { img.src = p.featured_image; img.alt = p.title; img.style.display = 'block'; } else { img.style.display = 'none'; }
        qs('[data-qv-link]', qv).href = root() + 'products/' + handle;
        qv.classList.add('is-open');
        qv.setAttribute('aria-hidden', 'false');
        lock(true);
      })
      .catch(function () { window.location.href = root() + 'products/' + handle; });
  }
  function closeQuickView() {
    var qv = qs('[data-bc-cr-quickview]');
    if (!qv) return;
    qv.classList.remove('is-open');
    qv.setAttribute('aria-hidden', 'true');
    lock(false);
  }

  /* ---------- video lightbox ---------- */
  function youtubeEmbed(url) {
    try {
      var u = new URL(url);
      if (u.hostname.indexOf('youtu.be') > -1) { var s = u.pathname.replace('/', ''); return s ? 'https://www.youtube.com/embed/' + s + '?autoplay=1&rel=0' : ''; }
      if (u.hostname.indexOf('youtube.com') > -1) {
        if (u.pathname.indexOf('/shorts/') > -1) { var sp = u.pathname.split('/shorts/'); if (sp[1]) return 'https://www.youtube.com/embed/' + sp[1] + '?autoplay=1&rel=0'; }
        var id = u.searchParams.get('v'); return id ? 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0' : '';
      }
    } catch (e) {}
    return '';
  }
  function vimeoEmbed(url) {
    try {
      var u = new URL(url);
      if (u.hostname.indexOf('vimeo.com') === -1) return '';
      var parts = u.pathname.split('/').filter(Boolean);
      var id = parts.length ? parts[parts.length - 1] : '';
      return id ? 'https://player.vimeo.com/video/' + id + '?autoplay=1' : '';
    } catch (e) { return ''; }
  }
  function isDirectVideo(url) { return /\.mp4(\?.*)?$|\.webm(\?.*)?$|\.ogg(\?.*)?$/i.test(url || ''); }

  function openVideo(url) {
    var lb = qs('[data-bc-cr-lightbox]'), content = qs('[data-bc-cr-lightbox-content]');
    if (!lb || !content || !url) return;
    var yt = youtubeEmbed(url), vm = vimeoEmbed(url), html = '';
    if (yt) html = '<iframe src="' + yt + '" title="Product video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    else if (vm) html = '<iframe src="' + vm + '" title="Product video" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    else if (isDirectVideo(url)) html = '<video controls autoplay playsinline><source src="' + url + '"></video>';
    else { window.open(url, '_blank'); return; }
    content.innerHTML = html;
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    lock(true);
  }
  function closeVideo() {
    var lb = qs('[data-bc-cr-lightbox]'), content = qs('[data-bc-cr-lightbox-content]');
    if (!lb || !content) return;
    content.innerHTML = '';
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    lock(false);
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var bar = t.closest && t.closest('.bc-cr-accordion');
    if (bar) { toggleBar(bar); return; }
    var tab = t.closest && t.closest('.bc-cr-tab');
    if (tab) { openTab(tab); return; }
    var addBtn = t.closest && t.closest('.bc-cr-add');
    if (addBtn) { e.preventDefault(); addToCart(addBtn.closest('.bc-cr-form')); return; }
    var rem = t.closest && t.closest('.bc-cr-remove');
    if (rem) { e.preventDefault(); removeFromCart(rem); return; }
    var view = t.closest && t.closest('.bc-cr-view');
    if (view) { e.preventDefault(); openQuickView(view.getAttribute('data-handle')); return; }
    var vid = t.closest && t.closest('.bc-cr-video');
    if (vid) { e.preventDefault(); openVideo(vid.getAttribute('data-video')); return; }
    if (t.closest && t.closest('[data-bc-cr-close]')) { closeVideo(); return; }
    if (t.closest && t.closest('[data-bc-cr-qv-close]')) { closeQuickView(); return; }
  });

  /* Variant picker: ADD/REMOVE and the in-cart check all read data-variant, so switching
     the picker re-points both, then refreshes price, photo and the ADD/REMOVE state. */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.classList || !sel.classList.contains('bc-cr-variant__select')) return;
    var item = sel.closest('.bc-cr-item');
    if (!item) return;
    var opt = sel.options[sel.selectedIndex];
    item.setAttribute('data-variant', sel.value);
    var form = qs('.bc-cr-form', item);
    if (form) form.setAttribute('data-variant', sel.value);
    var price = qs('.bc-cr-price', item);
    if (price) {
      var was = opt.getAttribute('data-compare');
      price.textContent = '';
      if (was) { var s = document.createElement('s'); s.textContent = was; price.appendChild(s); price.appendChild(document.createTextNode(' ')); }
      price.appendChild(document.createTextNode(opt.getAttribute('data-price') || ''));
    }
    var img = qs('img', item), src = opt.getAttribute('data-img');
    if (img && src) img.src = src;
    refreshCartCount();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeVideo(); closeQuickView(); }
  });

  function init() {
    var wraps = qsa(ROOT_SEL + ':not([data-ready])');
    if (!wraps.length) return false;
    wraps.forEach(function (w) {
      w.setAttribute('data-ready', '1');
      var first = qs('.bc-cr-tab', w);
      if (first) openTab(first);
    });
    refreshCartCount();
    return true;
  }

  /* The block may land after us (AJAX buy box) — poll briefly, then stop. */
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (init() || tries > 60) clearInterval(timer);
  }, 250);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
